import { am5, am5xy } from '@local/finsera-core/src/libs';

export const createXAxis = ({
  root,
  chart,
  dataLength,
  isLargeDataset,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  dataLength: number;
  isLargeDataset: boolean;
}) => {
  // Create axes
  const xAxis = chart.xAxes.push(
    am5xy.DateAxis.new(root, {
      baseInterval: { timeUnit: 'day', count: 1 },
      groupData: true,
      groupCount: isLargeDataset ? Math.min(500, Math.floor(dataLength / 2)) : undefined,
      maxDeviation: 0,
      renderer: am5xy.AxisRendererX.new(root, {
        minGridDistance: 40,
        minorGridEnabled: true,
      }),
      tooltip: am5.Tooltip.new(root, {}),
    })
  );

  xAxis.get('renderer').labels.template.setAll({
    fontSize: 11,
    textAlign: 'center',
  });

  return xAxis;
};
